@if (_isBlackScreenVisible) {
  <div
    class="black-screen-overlay"
    [class.active]="_isBlackScreenVisible"
    [class.dissolving]="_isDissolving"
    #overlayContainer>
    <div class="black-screen-content">
      @if (_overlayState === _overlayStateEnum.COUNTDOWN) {
        <div class="countdown-content">
          <div #countdownNumber class="countdown-number">{{ _countdown }}</div>
        </div>
      }

      @if (_overlayState === _overlayStateEnum.AWAY) {
        <div #awayContent class="away-content">
          <img
            #awayImage
            [src]="_awayImageFilename | assetUrl"
            alt="Away"
            class="away-image" />
          <h2 #awayTitle class="away-title">{{ _awayTitleText }}</h2>
          <p #awaySubtitle class="away-subtitle">{{ _awaySubtitleText }}</p>
          <div #awayDots class="away-dots">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
        </div>
      }

      @if (_overlayState === _overlayStateEnum.WELCOME) {
        <div #welcomeContent class="welcome-content">
          <h2 #welcomeTitle class="welcome-title">{{ _welcomeTitleText }}</h2>
          <p #welcomeSubtitle class="welcome-subtitle">
            {{ _welcomeSubtitleText }}
          </p>
        </div>
      }

      @if (_overlayState === _overlayStateEnum.DEVTOOLS) {
        <div #restrictedContent class="restricted-content">
          <img
            #restrictedImage
            [src]="_restrictedImageFilename | assetUrl"
            alt="Restricted"
            class="restricted-image" />
          <p #warningMessage class="warning-message">
            {{ _devtoolsMessageText }}
          </p>
          <p #helpText class="help-text">
            {{ _devtoolsHelpText }}
          </p>
        </div>
      }

      @if (_overlayState === _overlayStateEnum.PRINT) {
        <div #restrictedContent class="restricted-content">
          <img
            #restrictedImage
            [src]="_restrictedImageFilename | assetUrl"
            alt="Restricted"
            class="restricted-image" />
          <p #warningMessage class="warning-message">
            {{ _printMessageText }}
          </p>
          <p #helpText class="help-text">
            {{ _printHelpText }}
          </p>
        </div>
      }

      @if (_overlayState === _overlayStateEnum.FREEZE) {
        <div #restrictedContent class="restricted-content">
          <img
            #restrictedImage
            [src]="_restrictedImageFilename | assetUrl"
            alt="Frozen"
            class="restricted-image" />
          <p #warningMessage class="warning-message">
            {{ _freezeMessage }}
          </p>
          <p #helpText class="help-text">
            Please wait until the process completes.
          </p>
        </div>
      }
    </div>
  </div>
}
